const TrialService = () => {
    return {
        remainingDays: (endDate: string) => {
            const end = new Date(endDate);
            const now = new Date();
            const diffTime = end.getTime() - now.getTime();
            return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        },
    };
};

export default TrialService();
